import { render } from "./YRichtext.vue?vue&type=template&id=aec4c2e8&scoped=true"
import script from "./YRichtext.vue?vue&type=script&lang=js"
export * from "./YRichtext.vue?vue&type=script&lang=js"

import "./YRichtext.vue?vue&type=style&index=0&id=aec4c2e8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec4c2e8"]])

export default __exports__